module.exports = __webpack_public_path__ + "img/knight.6cbc4dea.png";